export enum FormState {
    Draft,
    Published
}
